import { render } from "@/components/pages/specialFeature/spWorkSupport/requirementSpBC002/RequirementSpBC002.html?vue&type=template&id=de9108b0&external"
import script from "@/components/pages/specialFeature/spWorkSupport/requirementSpBC002/RequirementSpBC002.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spWorkSupport/requirementSpBC002/RequirementSpBC002.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__